import React,{Component } from 'react';
import {variables} from './Variables.js';


export class Genero extends Component{
    
    constructor(props){
        super(props);
        // abajo definimos un area de generos que llenamos de los datos de la api (como la BD)
        // anterior VAMOS A CREAR EL MODULO POP UP QUE SE ABRA CUANDO QUERAMOS AÑADIR O EDITAR UN GENERO
         // definimos las variables que vamos a utilizar en la ventana del modelo
        this.state={
            generos:[],
            modalTitle:"",
            generonombre:"",
            generoid:0,

            //hasta aquí, ahora abajo en constantes const linea 51 aprox
           // guardo este como 01Genero.js y limpio en comentarios Genero.js 
            
        }
    }

    refreshList(){
         // cuando la respuesta está disponible, la convertimos en json y 
        // la asignamos a la url
        fetch(variables.API_URL+'generos')
        .then(response=>response.json())
        .then(data=>{
            // esta parte es complicada, mejor ir viendo qué saca por consola
            console.log(data)
            this.setState({generos:data});
        });
    }
    componentDidMount(){
        this.refreshList();
     }
     
    // PASO ANTERIOR 
   //viene del final. aquí definimos la función que actualizará las variables del edit o add
   // son un montón así que todo se desplaza abajo
   changeGeneroNombre =(e)=>{
 
    this.setState({generonombre:e.target.value});
}

 // ESTE MÉTODO ES EL PRIMERO QUE SE HACE EN EL PASO ANTERIOR (LUEGO DE OTROS CAMBIONS)
 // en él, seteamos el valor modalTitle, el id en cero y el name vacío
addClick(){
    this.setState({
        modalTitle:"Añade género",
        generoid:0,
        generonombre:""
        //los valores por defecto antes de añadir
        // el método de abajo editclick(dep) es casi igual
      
    });
}
  //dep es el parámetro del map (al inicio del <tbody>)
editClick(dep){
    this.setState({
        modalTitle:"Edita genero",
        generoid:dep.generoid,
        generonombre:dep.generonombre
        // en vez de vacíos como arriba, los default cogerán los valores que ya tienen 
    });
}

//añadimos el método que añadirá nuevo género a partir del método POST
// en el botón de ventana flotanmte de crear
createClick(){
    fetch(variables.API_URL+'generos',{
        method:'POST',
        headers:{
            'Accept':'application/json',
            'Content-Type':'application/json'
        },
        body:JSON.stringify({
            //pasamos el nuevo nombre como un json en el cuerpo del post
            generonombre:this.state.generonombre
        })
    })
    .then(res=>res.json())
    .then(res=>console.log(res))
    .then((result)=>{
        alert("refresque pantalla");
        // si ha funcionado damos alet result (da undefined)
        // y también refrescamos página
        this.refreshList();
    },(error)=>{
        alert('Creado');
        this.refreshList();
    })
}

// definimos los métodos de update y delete que serán llamados desde 
// la ventana flotante cuando se de a editar o A añadir
// cuando esté completo vamos abajo a líneas 296 y 304 y descomentamos los onClick
updateClick(){
    fetch(variables.API_URL+'generos',{
        method:'PUT',
        headers:{
            'Accept':'application/json',
            'Content-Type':'application/json'
        },
        body:JSON.stringify({
            // aquí necesitamos el id y el nombre
            generoid:this.state.generoid,
            generonombre:this.state.generonombre
        })
    })
    .then(res=>res.json())
    .then((result)=>{
        alert("refresque pantalla");
        this.refreshList();
    },(error)=>{
        alert('actualizado');
        this.refreshList();
    })
}
// el método delete (pasamos el parámetro dep, que es el nombre del map)
// del mismo modo que los primeros métodos de arriba debemos definir estado a partir de ese map
// de ese modo podemos sacar el dato que remplazará el ? de la query del state 
// como en los métodos anteriores updateclick y createclick
// cuando lo tenemos descomentamos en la 267 el onclik del html del boton
// con esto ya tenemos la página de generos, DE MOMENTO ahora VAMOS A libro:js
// ABRIR Y COPIAR TODO ESTE CODIGO EN  libro:js
deleteClick(dep){
    if(window.confirm('¿estás segura/o?')){     
        // this.setState({
        //     modalTitle:"borra genero",
        //     generoid:dep.generoid
        // });
    fetch(variables.API_URL+'generos',{
        method:'DELETE',
        headers:{
            'Accept':'application/json',
            'Content-Type':'application/json'
        },
        body:JSON.stringify({
            generoid:dep.generoid
        })
    })
    .then(res=>res.json())
    .then((result)=>{
        alert("refresque pantalla");
        this.refreshList();
    },(error)=>{
       alert("eliminado");
        this.refreshList();
    })
    }
}

   
    render(){
// necesitamos declarar las variables de estado en el método render de modo que las podamos usar en el html
// estas sobre todo se utilizarán cuando el pop-up de edit add
// del paso anterior
const {
    generos,
    modalTitle,
    generoid,
    generonombre
  // del paso anterior
 // ahora abajo de todo antes del cierre del último div y después de el cierre de la table
}=this.state;


        return(

            <div>
                {/* PASO ANTERIOR añadimos aqúi el boton que abrirá el modelo de ventana de add edit*/}
    <button type="button"
    className="btn btn-primary m-2 float-end"
    data-bs-toggle="modal"
    data-bs-target="#exampleModal"
    onClick={()=>this.addClick()}>
        Añadir Género
    </button>
    {/* PASO ANTERIOR  en el método addclick() arriba seteamos el modatTitle como Añade Género
    ahora en línea 227 o 229 añadimos el boton de editar */}
<table className="table table-striped">
    <thead>
    <tr>
        <th>
            GeneroId
        </th>
        <th>
            GeneroNombre   
        </th>
        <th>
            Opciones
        </th>
    </tr>
    </thead>
    <tbody>
        {generos.map((dep,index)=>
            <tr key={index}>
                <td>{dep.generoid}</td>
                <td>{dep.generonombre}</td>
                <td>
                <button type="button"
                className="btn btn-light mr-1"
                // PASO ANTERIOR esto será el boton de editar (viene después de arriba del boton de añadir nuevo)
                // la función de editar " editClick  "está justo debajo de addClik
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                onClick={()=>this.editClick(dep)}
                >
                    {/* añadimos iconos de bootstrap de delete y edit 
                                                  al loro que hay que cambiar class por className**/}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                     <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                     </svg>
                </button>

                <button type="button"
                className="btn btn-light mr-1"
                data-bs-target="#exampleModal"
                 onClick={()=>this.deleteClick(dep)}
                >
                              {/* añadimos iconos de bootstrap de delete y edit  subimos debajo del constructor refreshList
                              al loro que hay que cambiar class por className*/}
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                        </svg>
                </button>

                </td>
            </tr>
            )}
    </tbody>
    </table>
 {/* DEL PASO ANTERIOR
 aquí debemos definir el código html que va a mostrar la ventana popup de add y edit
  */}
  <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
<div className="modal-dialog modal-lg modal-dialog-centered">
<div className="modal-content">
   <div className="modal-header">
    {/* ePASO ANTERIOR  l título vendrá de LA VARIABLE */}
       <h5 className="modal-title">{modalTitle}</h5>
       <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
       ></button>
   </div>
    {/* PASO ANTERIOR  aquí metemos el text box que añade o edita un genero 
    cuando el valor de la variable cambia, definiremos una función 
    que lo actualice de modo simultáneo
    ir a línea 48, antes del render y debajo del componentDidMount*/}
   <div className="modal-body">
       <div className="input-group mb-3">
        <span className="input-group-text">GeneroNombre</span>
        <input type="text" className="form-control" name="nuevoGenero"
        value={generonombre}
        onChange={this.changeGeneroNombre}/>
       </div>
    {/* PASO ANTERIOR  vamos creando aquí boton de crear un nuevo género con su onClick función
    y arriba después de la línea 48 añadiendo las funciones que atienden estos botones
    esta será visible cuando el cliente quiere crear un nuevo género*/}
        {generoid==0?
        <button type="button"
        className="btn btn-primary float-start"
        //descomentamos las llamadas al método
        onClick={()=>this.createClick()}
        >Crear</button>
        :null}
  {/* PASO ANTERIOR este será visible cuando el cliente quiere actualizar un nuevo género
  entonces ahora tenemos que añadir un boton que abra el modelo de ventana de editar, añadir
  subimos arriba en el html justo después del primer div que está después del render
  ARRIBA DEL HTML (PASO ANTERIOR )*/}
        {generoid!=0?
        <button type="button"
        className="btn btn-primary float-start"
        //descomentamos las llamadas al método
        onClick={()=>this.updateClick()}
        >Actualizar</button>
        :null}
   </div>

</div>
</div> 
</div>
            </div>
        )
    }
}
// cuando terminamos ir arriba en App.js en src